import React, { useState } from 'react'
import "../../stylings/facility.css"
import { FaGraduationCap, FaHandshake } from 'react-icons/fa'
import { PiBuildingApartmentLight } from 'react-icons/pi'
import { IoFootballOutline } from 'react-icons/io5'
import { GiSportMedal } from 'react-icons/gi'
import jsonData from '../../assest/Json Files/offerings.json';


const Facilities = () => {

    const [offerClicked, setOfferClicked] = useState(1)
    const offerings = jsonData

    const filterOfferings = offerings.find(offeritem => offeritem.id === offerClicked)

    const handleCardClicked = (number) => {
        setOfferClicked(number)
    }


    return (
        <div className='facilities-container'>
            <div className="facilities-heading-wrapper">
                <div className="facilities-heading">
                    <div className="facilities-icon">
                        <FaHandshake />
                    </div>
                    <h3><span className="word-leader">What We</span> Offer</h3>
                </div>
                <div className="sub-heading">
                    <p>Way, Truth and Life Foundation School has widespread interest in the sphere of the quality education with the commitment to nurture the uniqueness of our students</p>
                </div>
                <div className="box-container">
                    <div className="box-wrapper">
                        <div className={offerClicked === 1 ? "box active" : "box"} onClick={() => handleCardClicked(1)}>
                            <div className="svg-container">
                                <FaGraduationCap />
                            </div>
                            <p>Academics</p>
                        </div>
                        <div className={offerClicked === 2 ? "box active" : "box"} onClick={() => handleCardClicked(2)}>
                            <div className="svg-container">
                                <PiBuildingApartmentLight />
                            </div>
                            <p>Campus</p>
                        </div>
                        <div className={offerClicked === 3 ? "box active" : "box"} onClick={() => handleCardClicked(3)}>
                            <div className="svg-container">
                                <IoFootballOutline />
                            </div>
                            <p>Sports</p>
                        </div>
                        <div className={offerClicked === 4 ? "box active" : "box"} onClick={() => handleCardClicked(4)}>
                            <div className="svg-container">
                                <GiSportMedal />
                            </div>
                            <p>Co-Curricular Activities</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="details-container">
                <div className="row" key={offerClicked}>
                    <div className="column col-sm-6 fade-slide">
                        <div className="img-container">
                            <img src={filterOfferings.imageurl} alt="" />
                        </div>
                    </div>
                    <div className="column col-sm-6 details-column fade-slide">
                        <div className="detail-wrapper">
                            <div className="svg-container">
                                {offerClicked === 1 ? <FaGraduationCap /> : offerClicked === 2 ? <PiBuildingApartmentLight /> : offerClicked === 3 ? <IoFootballOutline /> : offerClicked === 4 && <GiSportMedal />}
                            </div>
                            <p className="title">{filterOfferings.title}</p>
                            <p className='detail-body'>{filterOfferings.body}</p>
                            <ul>
                                {
                                    filterOfferings.featuresbullet.map((item) => (
                                        <li key={item.id}>{item.bulletname}</li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Facilities
